import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Dropdown, TextCallout1 } from 'blocket-ui'

const createStartOptions = (items, endItems, endValue) => {
  const selectedEndItem = endItems.find((item) => {
    return endValue === item.value
  })
  const options = [
    { label: 'Från', value: '', color: '#9a9999' },
    ...items.map((item) => {
      return {
        value: item.value,
        label: item.label,
        disabled: selectedEndItem && selectedEndItem.cmp < item.cmp,
      }
    }),
  ]

  return options
}

const createEndOptions = (items, startItems, startValue) => {
  const selectedStartItem = startItems.find((item) => {
    return startValue === item.value
  })
  const options = [
    { label: 'Till', value: '', color: '#9a9999' },
    ...items.map((item) => {
      return {
        value: item.value,
        label: item.label,
        disabled: selectedStartItem && selectedStartItem.cmp > item.cmp,
      }
    }),
  ]

  return options
}

const RangePair = ({ label, rangeStart, rangeEnd, onChange, currentQuery }) => {
  const startValue = currentQuery[rangeStart.queryKey] || ''
  const endValue = currentQuery[rangeEnd.queryKey] || ''

  const onStartChange = (e) => {
    const {
      target: { value },
    } = e
    onChange(e, rangeStart.queryKey, value)
  }

  const onEndChange = (e) => {
    const {
      target: { value },
    } = e
    onChange(e, rangeEnd.queryKey, value)
  }

  const startOptions = useMemo(
    () => createStartOptions(rangeStart.items, rangeEnd.items, endValue),
    [rangeStart.items, rangeEnd.items, endValue],
  )
  const endOptions = useMemo(() => createEndOptions(rangeEnd.items, rangeStart.items, startValue), [
    rangeEnd.items,
    rangeStart.items,
    startValue,
  ])

  return (
    <fieldset>
      <TextCallout1 tagName="legend">{label}</TextCallout1>
      <Dropdown
        style={{ marginTop: 8 }}
        size="tiny"
        options={startOptions}
        value={startValue}
        onChange={onStartChange}
      />
      <Dropdown
        style={{ marginTop: 4 }}
        size="tiny"
        options={endOptions}
        value={endValue}
        onChange={onEndChange}
      />
    </fieldset>
  )
}

RangePair.propTypes = {
  label: PropTypes.string.isRequired,
  rangeStart: PropTypes.shape({
    items: PropTypes.array,
    queryKey: PropTypes.string.isRequired,
  }),
  rangeEnd: PropTypes.shape({
    items: PropTypes.array,
    queryKey: PropTypes.string.isRequired,
  }),
  onChange: PropTypes.func.isRequired,
  currentQuery: PropTypes.object.isRequired,
}

export default RangePair
